const OFFICE_TYPES = {
  WORD: 'WORD',
  EXCEL: 'EXCEL',
  POWERPOINT: 'POWERPOINT',
}

const getOfficeTypeByFileExtension = (fileExtension: string): string | null => {
  if (['doc', 'docx'].includes(fileExtension)) {
    return OFFICE_TYPES.WORD
  }

  if (['xls', 'xlsx'].includes(fileExtension)) {
    return OFFICE_TYPES.EXCEL
  }

  if (['ppt', 'pptx'].includes(fileExtension)) {
    return OFFICE_TYPES.POWERPOINT
  }

  return null
}

const getFaviconByOfficeType = (type: string | null): string => {
  if (type === OFFICE_TYPES.WORD) return '/favicon-word.ico'
  if (type === OFFICE_TYPES.EXCEL) return '/favicon-excel.ico'
  if (type === OFFICE_TYPES.POWERPOINT) return '/favicon-powerpoint.ico'
  return '/favicon.ico'
}

const getNameByOfficeType = (type: string | null): string | null => {
  if (type === OFFICE_TYPES.WORD) return 'Word for the web'
  if (type === OFFICE_TYPES.EXCEL) return 'Excel for the web'
  if (type === OFFICE_TYPES.POWERPOINT) return 'PowerPoint for the web'
  return null
}

export {
  OFFICE_TYPES,
  getOfficeTypeByFileExtension,
  getFaviconByOfficeType,
  getNameByOfficeType,
}
